import React, { useState, useEffect } from 'react';
import {
    AppBar,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    LinearProgress,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Toolbar,
    Typography,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloseIcon from '@mui/icons-material/Close';
import JHApi from "../../../utils/JHApi";
import clsx from 'clsx';
import { FIELD_TYPES, WEEK_DAYS_SHORT, capitalize } from '../../../utils/utils';
import { Fields } from '../../Fields';

import { blue, grey, purple } from '@mui/material/colors';

const useStyles = makeStyles((theme) => ({
    cellHeader:{
        display: 'flex',
        margin: 'auto',
        borderRadius: '50%',
        width: 52,
        height: 52,
        justifyContent: 'center',
        alignItems: 'center'
    },
    isToday: {
        fontWeight: 'bold',
        backgroundColor: theme.palette.primary.main,
        color: 'white'
    },
    isNow: {
        /*backgroundColor: blue[100],*/
        scrollMarginTop: '50px'
    },
    publishPost: {
        padding: '8px 4px',
        border: '1px solid grey',
        borderRadius: 5
    },
    publishPostPlan: {
        opacity: 0.5
    },
    cellOnList: {
        transition: "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
    },
    userRow:{
        transition: "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
    },
    selected:{
        background: blue[100],
    },
    selectedCanDelete:{
        background: purple[200],
        '&:hover': {
            background: 'white',
        }
    },
    hidden:{
        backgroundColor: grey[400]
    },
    canSelect:{
        cursor: 'pointer',
        /*'&:hover': {
            background: blue[100],
        }*/
    },
    canFill:{
        cursor: 'pointer',
        '&:hover': {
            background: purple[200],
        }
    }
}));

function ScheduleMeetingInfo (props) {
    const scheduleMeetingInfo = props.scheduleMeetingInfo || {}
    const open = scheduleMeetingInfo.open || false

    const isAdmin = props.isAdmin
    const userId = props.userId

    const journeyData = props.journeyData || {}

    const defNewData = {
        email: journeyData.email,
        name: (journeyData.first_name || journeyData.last_name) ? (journeyData.first_name + ' ' + journeyData.last_name): undefined,
        phone: journeyData.phone
    }

    const type = props.type
    const meetingWith = props.meetingWith

    const scheduleStatus = props.scheduleStatus

    const [disabled, setDisabled] = useState(false);
    const [error, setError] = useState();
    const [newData, setNewData] = useState(defNewData);

    const handleClose = () => {
        setNewData(defNewData)
        props.onClose()
    }

    const handleSave = e => {
        e.preventDefault();

        let paramsToPass = {...newData, ...scheduleMeetingInfo, type, meetingWith}

        if (isAdmin){
            paramsToPass.userId = userId
        }

        setDisabled(true)

        JHApi.scheduleMeetingNew(paramsToPass,(response)=>{
            props.handlesSetSheduleStatus(response.scheduleStatus, response.slots, response.scheduledText)
            setDisabled(false)

            /*if (response.WA){
                const msg = "היי, קבעתי פגישה";
                const meetingLink = `https://wa.me/${response.WA}?text=${encodeURIComponent(msg)}`;

                window.open(meetingLink, '_self');
            }*/
        }, (error) => {
            if(error&&error.response&&error.response.data&&error.response.data.message){
                setError(error.response.data.message)
            } else {
                setError('Something went wrong')
            }
            setDisabled(false)
        })
    }

    const handleChangeField = e => {
        setNewData({...newData,[e.target.name]: e.target.value})
    };

    const getValue = (name, defaultValue) => {
        if (newData[name] !== undefined){
            return newData[name]
        } else {
            return defaultValue
        }
    }

    let fields = [
        { name: 'email', label: 'Email', defaultValue: '', type:FIELD_TYPES.TEXT, sm:12, required:true, inputType:'email'}, 
        { name: 'name', label: 'Name', defaultValue: '', type:FIELD_TYPES.TEXT, sm:12, required:true}, 
        { name: 'phone', label: 'Phone', defaultValue: '', type:FIELD_TYPES.TEXT, sm:12, required:true, inputType:'tel'}, 
    ]

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>
                {capitalize(type || '')}{meetingWith&&<> with {capitalize(meetingWith || '')}</>}
            </DialogTitle>
            {scheduleStatus === 'SCHEDULED'?<>
                <DialogContent>
                    <div dir="auto" dangerouslySetInnerHTML={{__html: scheduleMeetingInfo.scheduledText}} />
                </DialogContent>
                <DialogActions>
                    <Button disabled={disabled} onClick={handleClose} color="primary" size="small" aria-label="Ok">
                        Ok
                    </Button>
                </DialogActions>
            </>:<>
            {scheduleStatus === 'TAKEN'?<>
                <DialogContent>
                    <Typography>This time is taken, Please choose another time</Typography>
                </DialogContent>
                <DialogActions>
                    <Button disabled={disabled} onClick={handleClose} color="primary" size="small" aria-label="Ok">
                        Ok
                    </Button>
                </DialogActions>
            </>:
            <form onSubmit={handleSave}>
                <DialogContent>
                    {(error)&&<Typography color="error">{error}</Typography>}
                    <Fields fields={fields} getValue={getValue} handleChange={handleChangeField}/>
                </DialogContent>
                <DialogActions>
                    <Button disabled={disabled} onClick={handleClose} color="primary" size="small" aria-label="Cancel">
                        Cancel
                    </Button>
                    <Button
                        disabled={disabled}
                        type="submit"
                        variant="outlined"
                        color="primary"
                        size="small"
                        aria-label='Schedule'
                    >
                        Schedule
                    </Button>
                </DialogActions>
            </form>}
            </>}
        </Dialog>
    )
}

function ScheduleMeetingSlotsContent(props) {
    const type = props.type
    const meetingWith = props.meetingWith
    const isAdmin = props.isAdmin
    const userId = props.userId
    const isDialog = props.isDialog || false

    const defaultStartDate = new Date()
    //defaultStartDate.setDate(defaultStartDate.getDate() - defaultStartDate.getDay())

    //const [needFetchData, setNeedFetchData] = useState(true);
    const [slots, setSlots] = useState([]);
    const [firstDate, setfirstDate] = useState(defaultStartDate);
    const [isFetching, setIsFetching] = useState(false);
    const [scheduleMeetingInfo, setScheduleMeetingInfo] = useState({});

    const [scheduleStatus, setScheduleStatus] = useState();

    const ARROWS_WIDTH = 52
    const COLUMN_WIDTH = 120
    const MENU_WIDTH = (isDialog || window.innerWidth <= 768) ? 0 : 240

    let pageWidth = window.innerWidth - MENU_WIDTH
    if (pageWidth > 1280){
        pageWidth = 1280
    }

    const columns = Math.floor((pageWidth - ARROWS_WIDTH * 2) / COLUMN_WIDTH)

    useEffect(() => {
        if (type){
            let paramsToPass = {type, meetingWith}

            if (isAdmin){
                paramsToPass.userId = userId
            }

            setIsFetching(true)

            JHApi.fetchMeetingSlots(paramsToPass,(response)=>{
                setSlots(response.slots || [])

                setIsFetching(false)
                //setIsFetchingMeetings(false)
            }, (error) => {
                setIsFetching(false)
                //setIsFetchingMeetings(false)
            })
        } else {
            setSlots([])
        }

        //setNeedFetchData(false)
    }, [type, meetingWith, isAdmin, userId]);

    /*useEffect(() => {
        let secTimer = setInterval( () => {
            setNeedFetchData(true)
        },30000)

        return () => clearInterval(secTimer);
    }, []);*/

    const handlePrev = () => {
        const newFirstDate = new Date(firstDate)
        newFirstDate.setDate(newFirstDate.getDate() - columns)

        setfirstDate(newFirstDate)
    }

    const handleNext = () => {
        const newFirstDate = new Date(firstDate)
        newFirstDate.setDate(newFirstDate.getDate() + columns)

        setfirstDate(newFirstDate)
    }

    const handleChooseDate = slotForDate => {
        setScheduleStatus()
        setScheduleMeetingInfo({...slotForDate, open: true})
    }

    const handlesSetSheduleStatus = (newSheduleStatus, newSlots, scheduledText) => {
        setSlots(newSlots)
        setScheduleStatus(newSheduleStatus)
        if (scheduledText){
            setScheduleMeetingInfo({scheduledText, open: true})
        } else {
            setScheduleMeetingInfo({})
        }
    }

    const today = new Date()
    const classes = useStyles();
    
    return (
        <>
            <ScheduleMeetingInfo  {...props} scheduleMeetingInfo={scheduleMeetingInfo} onClose={()=>setScheduleMeetingInfo({})} scheduleStatus = {scheduleStatus} handlesSetSheduleStatus={handlesSetSheduleStatus}/>
            {scheduleStatus === 'SCHEDULED' ? <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 24}}>
                <Typography variant='h4'>The meeting is Scheduled, Check you email</Typography>
            </div>: <>
                {isFetching?<LinearProgress/>:
                <Table stickyHeader size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell style={{width:ARROWS_WIDTH, textAlign: 'center'}}>
                                <IconButton style={{padding: 0}} color='primary' onClick={handlePrev} size="large">
                                    <ChevronLeftIcon fontSize='small' />
                                </IconButton>
                            </TableCell>
                            {[...Array(columns)].map((x, i) => {
                                let date = new Date(firstDate)
                                date.setDate(date.getDate() + i)

                                const isToday = (date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear())

                                return (
                                    <TableCell key={date}>
                                        <div className={clsx(classes.cellHeader,isToday&&classes.isToday)}>
                                            <div>
                                                <div style={{
                                                    textAlign: 'center',
                                                    fontSize: 12,
                                                    lineHeight: '16px'
                                                }}>{WEEK_DAYS_SHORT[date.getDay()]}</div>
                                                <div style={{
                                                    fontSize: 16,
                                                    lineHeight: '28px'
                                                }}>{date.getDate()}.{date.getMonth()+1}</div>
                                            </div>
                                        </div>
                                    </TableCell>
                                )
                            })}
                            <TableCell style={{width:ARROWS_WIDTH, textAlign: 'center'}}>
                                <IconButton style={{padding: 0}} color='primary' onClick={handleNext} size="large">
                                    <ChevronRightIcon fontSize='small' />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell style={{borderBottom: 'none'}}></TableCell>
                            {[...Array(columns)].map((x, i) => {
                                let date = new Date(firstDate)
                                date.setDate(date.getDate() + i)

                                const slotsForDate = slots.filter(slot => (new Date(slot.start).getFullYear() === date.getFullYear() && new Date(slot.start).getMonth() === date.getMonth() && new Date(slot.start).getDate() === date.getDate())).sort((a, b) => new Date(a.start) - new Date(b.start));

                                return (
                                    <TableCell key={date} style={{verticalAlign: 'top', borderBottom: 'none'}}>
                                        {slotsForDate.map((slotForDate) => (
                                            <div key={slotForDate.start} style={{
                                                    margin: '8px 0',
                                                    border: '1px solid #747775',
                                                    borderRadius: 50,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '4px 8px',
                                                    cursor: 'pointer',
                                                    minWidth: 76
                                                }} onClick={()=>handleChooseDate(slotForDate)}
                                            >
                                                <Typography style={{fontSize: 14}} color='primary'>{slotForDate.hourInIsrael} : {slotForDate.minuteInIsrael.toString().padStart(2, '0')}</Typography>
                                            </div>
                                            ))}
                                    </TableCell>
                                )
                            })}
                            <TableCell style={{borderBottom: 'none'}}></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>}
            </>}
        </>
    );
}

export default function ScheduleMeetingSlots(props) {
    const params = new URLSearchParams(window.location.search);    

    const isDialog = props.isDialog || false
    const type = params.get('type') || props.type
    const meetingWith = params.get('with') || props.with

    const loginNeeded = (type === 'follow-up' && props.loginChecked && !props.isAuthed)

    useEffect(() => {
        if (loginNeeded){
            props.handleLogin()
        }
    }, [loginNeeded]);

    return (
        <>
            {isDialog?<Dialog open={open} onClose={props.onClose} fullScreen>
                <AppBar position="static" color="default">
                    <Toolbar>
                        <Typography variant="h6" color="inherit" style={{flex:1}}>
                            {capitalize(type || '')}{meetingWith&&<> with {capitalize(meetingWith || '')}</>}
                        </Typography>
                        <div style={{flex:1}}></div>
                        <IconButton aria-label="close" color="inherit" onClick={props.onClose} size="large">
                            <CloseIcon/>
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent style={{padding:0}}>
                    {loginNeeded?<div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 24}}>
                        <Typography variant='h4'>Please Log In to continue</Typography>
                    </div>:
                    <ScheduleMeetingSlotsContent {...props} type={type} meetingWith={meetingWith}/>}
                </DialogContent>
            </Dialog>:
            <div>
                {loginNeeded?<div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 24}}>
                    <Typography variant='h4'>Please Log In to continue</Typography>
                </div>:
                <ScheduleMeetingSlotsContent {...props} type={type} meetingWith={meetingWith}/>}
            </div>}
        </>
    );
}